export default __webpack_public_path__ + "dist/media/Circle-check.85fa8c60.svg";